import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './auth/AuthContext';
import PrivateRoute from './routes/PrivateRoute';
import SignIn from './components/SignIn';
import Calendar from './components/Calendar';
import NewOrder from './components/NewOrder';
import OrderDetail from './components/OrderDetail';
import Companies from './components/Companies';
import ChangePassword from './components/ChangePassword';
import Orders from './components/Orders';
import './index.css';

export default function App() {
  return (
    <Router>
      <AuthProvider>
        <Routes>
          <Route path="/signin" element={<SignIn />} />
          <Route element={<PrivateRoute />}>
            <Route path="/change-password" element={<ChangePassword />} />
            <Route path="/" element={<Calendar />} />
            <Route path="/orders" element={<Orders />} />
            <Route path="/order/new" element={<NewOrder />} />
            <Route path="/order/:id" element={<OrderDetail />} />
            <Route path="/companies" element={<Companies />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AuthProvider>
    </Router>
  );
}
